import React from 'react';
import { useTranslation } from 'react-i18next';

const Home = () => {
    const { t } = useTranslation();

    return (
        <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">{t('home.title')}</h1>
            <p className="text-xl md:text-2xl mb-6">{t('home.description')}</p>

            <h2 className="text-2xl md:text-3xl font-semibold mb-2">{t('home.whatIsIt')}</h2>
            <p className="mb-6">{t('home.explanation')}</p>

            <div className="md:flex md:items-start md:justify-between mb-6">
                <div className="md:w-2/3">
                    <h2 className="text-2xl md:text-3xl font-semibold mb-2">{t('home.howItHelps')}</h2>
                    <ul className="list-none mb-6 md:mb-0">
                        {t('home.benefits', { returnObjects: true }).map((benefit, index) => (
                            <li key={index} className="mb-2">{benefit}</li>
                        ))}
                    </ul>
                </div>
                <div className="flex justify-center md:w-1/3 md:justify-end">
                    <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" className="w-32 h-32 md:w-64 md:h-64" />
                </div>
            </div>

            <p className="text-lg md:text-xl mb-6">{t('home.conclusion')}</p>

            <p className="text-xl md:text-2xl font-bold">{t('home.callToAction')}</p>
        </div>
    );
};

export default Home;